module.exports = __webpack_public_path__ + "img/lpc.f08651d7.png";